import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  // mode: 'history', // 设置为 history 模式
  // 路由配置
  routes: [
    { path: '/', redirect: '/index' }, // 将根路径重定向到 /index
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/register.vue')
    },
    {
      path: '/goodlist',
      name: 'goodlist',
      component: () => import('../views/goodlist.vue')
    },
    {
      path: '/goodlist2',
      name: 'goodlist2',
      component: () => import('../views/goodlist2.vue')
    },
    {
      path: '/goodlist3',
      name: 'goodlist3',
      component: () => import('../views/goodlist3.vue')
    },
    {
      path: '/goodview',
      name: 'goodview',
      component: () => import('../views/goodview.vue')
    },
    {
      path: '/preOrder',
      name: 'preOrder',
      component: () => import('../views/preOrder.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/shoppingCar',
      name: 'shoppingCar',
      component: () => import('../views/shoppingCar.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: () => import('../views/orderlist.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/ordermore',
      name: 'ordermore',
      component: () => import('../views/ordermore.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/person',
      name: 'person',
      component: () => import('../views/person.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/personedit',
      name: 'personedit',
      component: () => import('../views/personedit.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/password',
      name: 'password',
      component: () => import('../views/password.vue')
    },
    {
      path: '/chongzhi',
      name: 'chongzhi',
      component: () => import('../views/chongzhi.vue')
    },
    {
      path: '/lsmxlist',
      name: 'lsmxlist',
      component: () => import('../views/lsmxlist.vue')
    },
    {
      path: '/404error',
      name: '404error',
      component: () => import('../views/404error.vue')
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import('../views/welcome.vue')
    },
  ]
});
// // 全局导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.query.refresh) {
//     // 强制刷新页面
//     window.location.reload();
//   } else {
//     next(); // 继续导航到目标路由
//   }
// });
// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('user'); // 检查缓存中是否存在登录状态

  // 如果目标路由需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果缓存中没有登录状态
    if (!isLoggedIn) {
      // 重定向到登录页面，并传递当前路径作为查询参数
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      // 缓存中有登录状态，继续访问目标路由
      next();
    }
  } else {
    // 目标路由不需要登录权限，继续访问
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js